import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

import MakulerMiljokontroll from "./MakulerMiljokontroll";

import {
    getAllMiljoKontrollHistorikk,
    getMiljokontroll,
    getMiljokontroller,
    putMiljokontrollAvslutt,
} from "../../../../actions/miljokontrollerActions";

export default function MakulerMiljokontrollContainer() {
  const dispatch = useDispatch();
  const miljokontroll = useSelector((state) => state.miljokontroll);
  const miljokontrollOversiktFilterForm = useSelector(
    (state) => state.forms.miljokontrollOversiktFilterForm
  );
  const putMiljokontrollAvsluttAction = useCallback(
    () =>
      dispatch(
        putMiljokontrollAvslutt(
          miljokontroll.id,
          { avslutt: true },
          () => dispatch(getMiljokontroller(miljokontrollOversiktFilterForm)),
          () => dispatch(getMiljokontroll(miljokontroll.id)),
          () => dispatch(getAllMiljoKontrollHistorikk(miljokontroll.id))
        )
      ),
    [dispatch, miljokontroll, miljokontrollOversiktFilterForm]
  );

  return (
    <MakulerMiljokontroll
      miljokontroll={miljokontroll}
      putMiljokontrollAvslutt={putMiljokontrollAvsluttAction}
    />
  );
}
